import {FilterMatchMode, FilterOperator} from "primereact/api";
import {
    ADD_MONITORING_OBJECT,
    ADD_TO_MONITORING_LIST,
    CHANGED_MONITORING_DATA, CLEAR_CONSULTATION_FOR_SIP,
    CLEAR_MONITORING_FILTERS,
    CLEAR_MONITORING_FOR_SIP,
    GET_AUDIO_URL,
    GET_CALL_RESET_DICTIONARY, GET_CALL_TYPE_DICTIONARY,
    GET_CAMPAIGN_NAME_LIST, GET_CONSULTATION_FOR_SIP, GET_DIRECTION_DICTIONARY,
    GET_FORCED_CLOSING_DICTIONARY,
    GET_MONITORING,
    GET_MONITORING_FOR_SIP,
    GET_MONITORING_PAGINATION, GET_MONITORING_QUEUE,
    GET_MONITORINGS, GET_NEW_MONITORING_QUEUE, GET_OWNER_TYPE_DICTIONARY,
    GET_STATUS_DICTIONARY,
    HIDE_ERROR,
    HIDE_ERROR_MESSAGE,
    HIDE_LOADER,
    HIDE_MONITORING_CREATE_MESSAGE,
    HIDE_MONITORING_SAVE_MESSAGE,
    INITIAL_MONITORING_DATA,
    MONITORING_DIALOG_VISIBLE,
    MONITORING_FIELD,
    MONITORING_RELOAD_TOGGLE,
    MONITORING_STATE_SAVE,
    MONITORING_TABLE_TOGGLE,
    SELECTED_MONITORING_ID,
    SET_CURRENT_MONITORING_PAGE,
    SET_CURRENT_MONITORING_SIZE,
    SET_ERROR_FIELDS,
    SET_FIRST_PAGE, SET_MONITORING_FILTER, GET_MONITORING_DASHBOARD, SET_MONITORING_DASHBOARD_LOADING, SET_SPEAKING_AUDIO,
    SHOW_DETAIL_LOADING,
    SHOW_ERROR,
    SHOW_ERROR_FIELD,
    SHOW_ERROR_MESSAGE,
    SHOW_EXPORT_LOADING,
    SHOW_LOADER,
    SHOW_MONITORING_CREATE_MESSAGE,
    SHOW_MONITORING_DELETE_MESSAGE, SHOW_MONITORING_QUEUE_LOADER,
    SHOW_MONITORING_SAVE_MESSAGE,
    SHOW_SIP_DETAILS_LOADING,
    SHOW_UPDATED_ERROR, UPDATE_MONITORING_FILTER, SET_MONITORING_UI_FILTERS, SET_QUEUE_MONITOR_STATS, REMOVE_FROM_MONITORING_QUEUE
} from "../types/typesMonitoringList";
import {AUDIO_LOADING, UPLOAD_AUDIO_LOADING, CLEAR_ALL_STATES, SET_AUDIO_UNAVAILABLE} from "../types/types";
import {SET_CHECK_USER_FOR_BAN} from "../types/typesUsersList";

const getInitialQueueMonitorStats = () => {
    try {
        const saved = localStorage.getItem('queueMonitorStats');
        if (saved) {
            return JSON.parse(saved);
        }
    } catch (error) {
        console.warn('Failed to parse queueMonitorStats from localStorage:', error);
    }
    return {
        countActiveCalls: 0,
        withNotification: false
    };
};

const initialState = {
    monitoringTableToggle: 'table1',
    isSpeakingAudio: false,
    dialogVisible: false,
    autoReload: false,
    selectedMonitoringId: null,
    clearFilters: {
        userName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        ani: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        aNumber: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        ownerUserName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        fullName: {value: null, matchMode: FilterMatchMode.IN},
        ownerType: {value: null, matchMode: FilterMatchMode.IN},
        campaignFullName: {value: null, matchMode: FilterMatchMode.IN},
        branchId: {value: null, matchMode: FilterMatchMode.IN},
        queueFullName: {value: null, matchMode: FilterMatchMode.IN},
        status: {value: null, matchMode: FilterMatchMode.IN},
        callResetName: {value: null, matchMode: FilterMatchMode.IN},
        forcedClosing: {value: null, matchMode: FilterMatchMode.IN},
        callType: {value: null, matchMode: FilterMatchMode.IN},
        direction: {value: null, matchMode: FilterMatchMode.IN},
        campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        start: {value: null, matchMode: FilterMatchMode.IN},
        fullCallDuration: {value: null, matchMode: FilterMatchMode.IN},
        duration: {value: null, matchMode: FilterMatchMode.IN},
        reactionClient: {value: null, matchMode: FilterMatchMode.IN},
        reactionOperator: {value: null, matchMode: FilterMatchMode.IN},
        end: {value: null, matchMode: FilterMatchMode.IN},
    },
    monitoringList: [],
    monitoringQueueList: [],
    newMonitoringQueueList: [],
    monitoringQueueLoader: false,
    campaignListName: [],
    checkUserForBan: false,
    pagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    monitoringData: {
        duration: null,
        phoneNo: null,
        contactName: null,
        description: null,
        url: null,
        end: null,
        id: null,
        campaignId: null,
        campaignName: null,
        nameFrom: null,
        nameTo: null,
        status: null,
        typeChannel: null,
        start: null,
        direction: null,
        isDeclined: false,
        username: null,
        hasDetails: false,
        sessionId: null,
        amdHangup: null,
        callReset: null
    },
    monitoringSipData: {
        duration: null,
        phoneNo: null,
        contactName: null,
        description: null,
        url: null,
        end: null,
        id: null,
        campaignId: null,
        campaignName: null,
        nameFrom: null,
        nameTo: null,
        status: null,
        typeChannel: null,
        start: null,
        direction: null,
        isDeclined: false,
        username: null,
        hasDetails: false,
        sessionId: null,
        amdHangup: null,
        callReset: null
    },
    consultationSipData: {
        duration: null,
        phoneNo: null,
        contactName: null,
        description: null,
        url: null,
        end: null,
        id: null,
        campaignId: null,
        campaignName: null,
        nameFrom: null,
        nameTo: null,
        status: null,
        typeChannel: null,
        start: null,
        direction: null,
        isDeclined: false,
        username: null,
        hasDetails: false,
        sessionId: null,
        amdHangup: null,
        callReset: null
    },
    audioUrl: null,
    audioUrlLoading: false,
    audioUrlUploadLoading: false,
    audioUnavailable: false,
    loading: false,
    exportLoading: false,
    detailsLoading: false,
    sipDetailsLoading: false,
    error: false,
    errorUpdate: false,
    errorMessage: null,
    monitoringCreateMessage: false,
    monitoringSaveMessage: false,
    monitoringDeleteMessage: false,
    monitoringStateSave: false,
    errorField: null,
    errorFields: null,
    pageChanged: false,
    statusDictionary: null,
    callResetDictionary: null,
    forcedClosingDictionary: null,
    ownerTypeDictionary: null,
    monitoringFilterData: null,
    monitoringDashboard: null as any,
    monitoringDashboardLoading: false,
    directionDictionary: null,
    callTypeDictionary: null,
    queueMonitorStats: getInitialQueueMonitorStats()
}

export const MonitoringListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case MONITORING_TABLE_TOGGLE:
            return {...state, monitoringTableToggle: action.payload}
        case MONITORING_DIALOG_VISIBLE:
            return {...state, dialogVisible: action.payload}
        case SELECTED_MONITORING_ID:
            return {...state, selectedMonitoringId: action.payload}
        case MONITORING_FIELD:
            return {
                ...state, monitoringData:
                    {
                        ...state.monitoringData,
                        [action.payload.section]: {
                            // @ts-ignore
                            ...state.monitoringData[action.payload.section],
                            [action.payload.fieldName]: action.payload.value,
                        }
                    }
            }
        case CLEAR_MONITORING_FILTERS:
            return {
                ...state, clearFilters: {
                    userName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    aNumber: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    ownerUserName: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    ownerType: {value: null, matchMode: FilterMatchMode.IN},
                    ani: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    fullName: {value: null, matchMode: FilterMatchMode.IN},
                    campaignFullName: {value: null, matchMode: FilterMatchMode.IN},
                    branchId: {value: null, matchMode: FilterMatchMode.IN},
                    queueFullName: {value: null, matchMode: FilterMatchMode.IN},
                    status: {value: null, matchMode: FilterMatchMode.IN},
                    callResetName: {value: null, matchMode: FilterMatchMode.IN},
                    forcedClosing: {value: null, matchMode: FilterMatchMode.IN},
                    callType: {value: null, matchMode: FilterMatchMode.IN},
                    direction: {value: null, matchMode: FilterMatchMode.IN},
                    campaignId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    start: {value: null, matchMode: FilterMatchMode.IN},
                    fullCallDuration: {value: null, matchMode: FilterMatchMode.IN},
                    duration: {value: null, matchMode: FilterMatchMode.IN},
                    reactionClient: {value: null, matchMode: FilterMatchMode.IN},
                    reactionOperator: {value: null, matchMode: FilterMatchMode.IN},
                    end: {value: null, matchMode: FilterMatchMode.IN}
                }
            }
        case GET_MONITORINGS:
            return {...state, monitoringList: action.payload}
        case GET_MONITORING_QUEUE:
            return {...state, monitoringQueueList: action.payload}
        case GET_NEW_MONITORING_QUEUE:
            return {...state, newMonitoringQueueList: action.payload}
        case SHOW_MONITORING_QUEUE_LOADER:
            return {...state, monitoringQueueLoader: action.payload}
        case GET_CAMPAIGN_NAME_LIST:
            return {...state, campaignListName: action.payload}
        case GET_MONITORING_PAGINATION:
            return {...state, pagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_MONITORING_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_CURRENT_MONITORING_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_MONITORING:
            return {...state, monitoringData: action.payload}
        case GET_MONITORING_FOR_SIP:
            return {...state, monitoringSipData: action.payload}
        case CLEAR_MONITORING_FOR_SIP:
            return {...state, monitoringSipData: initialState.monitoringSipData}
        case GET_CONSULTATION_FOR_SIP:
            return {...state, consultationSipData: action.payload}
        case CLEAR_CONSULTATION_FOR_SIP:
            return {...state, consultationSipData: initialState.consultationSipData}
        case SHOW_LOADER:
            return {...state, loading: true}
        case HIDE_LOADER:
            return {...state, loading: false}
        case SHOW_ERROR:
            return {...state, error: true}
        case SHOW_UPDATED_ERROR:
            return {...state, errorUpdate: true}
        case SHOW_MONITORING_CREATE_MESSAGE:
            return {...state, monitoringCreateMessage: true}
        case SHOW_MONITORING_SAVE_MESSAGE:
            return {...state, monitoringSaveMessage: true}
        case SHOW_MONITORING_DELETE_MESSAGE:
            return {...state, monitoringDeleteMessage: action.payload}
        case HIDE_MONITORING_CREATE_MESSAGE:
            return {...state, monitoringCreateMessage: false}
        case HIDE_MONITORING_SAVE_MESSAGE:
            return {...state, monitoringSaveMessage: false}
        case HIDE_ERROR:
            return {...state, error: false, errorUpdate: false}
        case MONITORING_STATE_SAVE:
            return {...state, monitoringStateSave: action.payload}
        case INITIAL_MONITORING_DATA:
            return {...state, monitoringData: initialState.monitoringData}
        case CLEAR_ALL_STATES:
            const originalTitle = document.title.replace(/^\s*\(\d+\)\s*/, '');
            document.title = originalTitle;
            return initialState
        case SHOW_ERROR_MESSAGE:
            return {...state, errorMessage: action.payload}
        case SHOW_DETAIL_LOADING:
            return {...state, detailsLoading: action.payload}
        case SHOW_SIP_DETAILS_LOADING:
            return {...state, sipDetailsLoading: action.payload}
        case SHOW_EXPORT_LOADING:
            return {...state, exportLoading: action.payload}
        case SHOW_ERROR_FIELD:
            return {...state, errorField: action.payload}
        case SET_ERROR_FIELDS:
            return {...state, errorFields: action.payload}
        case HIDE_ERROR_MESSAGE:
            return {...state, errorMessage: null}
        case CHANGED_MONITORING_DATA:
            return {...state, changedMonitoringData: action.payload}
        case GET_AUDIO_URL:
            return {
                ...state,
                audioUrl: action.payload,
                audioUnavailable: action.payload ? false : state.audioUnavailable,
            };
        case SET_AUDIO_UNAVAILABLE:
            return {...state, audioUnavailable: action.payload};
        case AUDIO_LOADING:
            return {...state, audioUrlLoading: action.payload}
        case UPLOAD_AUDIO_LOADING:
            return {...state, audioUrlUploadLoading: action.payload}
        case ADD_MONITORING_OBJECT:
            return {...state, monitoringList: [action.payload, ...state.monitoringList]};
        case SET_CHECK_USER_FOR_BAN:
            return {...state, checkUserForBan: action.payload};
        case ADD_TO_MONITORING_LIST:
            return {...state, monitoringList: [action.payload, ...state.monitoringList]};
        case MONITORING_RELOAD_TOGGLE:
            return {...state, autoReload: action.payload}
        case SET_FIRST_PAGE:
            return {...state, pageChanged: action.payload}
        case GET_STATUS_DICTIONARY:
            return {...state, statusDictionary: action.payload}
        case GET_CALL_RESET_DICTIONARY:
            return {...state, callResetDictionary: action.payload}
        case GET_FORCED_CLOSING_DICTIONARY:
            return {...state, forcedClosingDictionary: action.payload}
        case GET_OWNER_TYPE_DICTIONARY:
            return {...state, ownerTypeDictionary: action.payload}
        case SET_MONITORING_FILTER:
            return {...state, monitoringFilterData: action.payload}
        case GET_MONITORING_DASHBOARD:
            return {...state, monitoringDashboard: action.payload}
        case SET_MONITORING_DASHBOARD_LOADING:
            return {...state, monitoringDashboardLoading: action.payload}
        case GET_DIRECTION_DICTIONARY:
            return {...state, directionDictionary: action.payload}
        case GET_CALL_TYPE_DICTIONARY:
            return {...state, callTypeDictionary: action.payload}
        case SET_SPEAKING_AUDIO:
            return {...state, isSpeakingAudio: action.payload}
        case UPDATE_MONITORING_FILTER:
            const { field, value } = action.payload;
            // @ts-ignore
            const currentFilter = state.clearFilters[field];

            if (!currentFilter) return state;

            let updatedField;

            if ('constraints' in currentFilter) {
                updatedField = {
                    ...currentFilter,
                    constraints: [
                        {
                            ...currentFilter.constraints[0],
                            value: value
                        }
                    ]
                };
            } else {
                updatedField = {
                    ...currentFilter,
                    value: value
                };
            }

            return {
                ...state,
                clearFilters: {
                    ...state.clearFilters,
                    [field]: updatedField
                }
            };
        case SET_MONITORING_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        case SET_QUEUE_MONITOR_STATS:
            return {
                ...state,
                queueMonitorStats: {
                    countActiveCalls: action.payload.countActiveCalls || 0,
                    withNotification: action.payload.withNotification || false
                }
            };
        case REMOVE_FROM_MONITORING_QUEUE:
            const filteredList = state.monitoringQueueList?.filter((item: any) => item.sessionId !== action.payload);
            const wasRemoved = filteredList && state.monitoringQueueList && filteredList.length < state.monitoringQueueList.length;
            
            return {
                ...state,
                monitoringQueueList: filteredList,
                queueMonitorStats: wasRemoved ? {
                    ...state.queueMonitorStats,
                    countActiveCalls: Math.max(0, (state.queueMonitorStats?.countActiveCalls || 0) - 1)
                } : state.queueMonitorStats
            };
        default:
            return state
    }
}
